var React = require('react');

function EditScheduleIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M20 3H4a1 1 0 0 0-1 1v2h18V4a1 1 0 0 0-1-1zM1 4v15a4 4 0 0 0 4 4h5.636a1 1 0 0 0 0-2H5a2 2 0 0 1-2-2V8h18v2.281a1 1 0 1 0 2 0V4a3 3 0 0 0-3-3H4a3 3 0 0 0-3 3zm13.823 14.586 4.835-4.83c.15.029.454.153.892.591.257.257.44.502.556.712.073.133.11.235.129.307l-4.817 4.81a.25.25 0 0 1-.177.074H14.75v-1.487a.25.25 0 0 1 .073-.177zm6.787-5.3c-.65-.649-1.376-1.072-2.108-1.034-.43.023-.731.27-.889.428l-4.85 4.845a1.75 1.75 0 0 0-.513 1.238v2.987h2.991a1.75 1.75 0 0 0 1.237-.512l4.85-4.844c.154-.154.423-.472.422-.932 0-.391-.14-.78-.33-1.127a4.76 4.76 0 0 0-.81-1.05z","fill":"#fff"}));
}

EditScheduleIcon.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = EditScheduleIcon;

EditScheduleIcon.default = EditScheduleIcon;
